import { render, staticRenderFns } from "./NewObservacion.vue?vue&type=template&id=547240fe&"
import script from "./NewObservacion.vue?vue&type=script&lang=js&"
export * from "./NewObservacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports